// 担保人邮箱：每个担保人的 ICA 来信有没有转发到 ss@kaider.sg（验证码、申诉结果都靠它）。文员和管理员都能看，不能改
import { Link } from "react-router-dom";
import type { SponsorMailDTO, TaskStatus } from "@csp/shared";
import { api } from "../lib/api";
import { fmtDateTime, fmtTime } from "../lib/format";
import { useLoad } from "../lib/hooks";
import { StatusBadge } from "../components/Badges";
import { DataTable, type Column } from "../components/DataTable";
import { PageHeading } from "../components/PageHeading";
import { SponsorMailBadge } from "../components/SponsorMail";

const COLUMNS: Column<SponsorMailDTO>[] = [
  { key: "email", label: "担保人邮箱", fixed: true, render: (s) => <span translate="no">{s.email}</span> },
  { key: "name", label: "姓名", render: (s) => <span translate="no">{s.name || "—"}</span> },
  { key: "status", label: "转发状态", fixed: true, render: (s) => <SponsorMailBadge status={s.status} /> },
  {
    key: "last",
    label: "最近收到 ICA 来信",
    render: (s) => (s.lastMailAt ? <span title={`${fmtDateTime(s.lastMailAt)} · ${s.lastMailSubject}`}>{fmtTime(s.lastMailAt)}</span> : <span className="muted">—</span>),
  },
  {
    key: "failed",
    label: "转发失败于",
    render: (s) => (s.status === "failed" && s.failedAt ? <span title={fmtDateTime(s.failedAt)}>{fmtTime(s.failedAt)}</span> : <span className="muted">—</span>),
  },
  {
    key: "tasks",
    label: "担保的任务",
    render: (s) =>
      s.tasks.length ? (
        <div className="row" style={{ gap: 6, flexWrap: "wrap" }}>
          {s.tasks.map((t) => (
            <Link key={t.id} to={`/tasks/${t.id}`} title={t.title}>
              #{t.no} <StatusBadge status={t.status as TaskStatus} />
            </Link>
          ))}
        </div>
      ) : (
        <span className="muted">—</span>
      ),
  },
];

export function SponsorMailsPage() {
  // 打开就回扫一次 ss@kaider.sg，状态是最新的
  const q = useLoad(() => api.sponsorMails(true), []);
  const rows = q.data ?? [];
  return (
    <div>
      <PageHeading
        title="担保人邮箱"
        desc="开始前担保人要把 ICA 来信转发到 ss@kaider.sg：验证码靠它自动填，申诉结果也靠它才知道。ss 收到过发给他的 ICA 来信就是「已转发」；等验证码时没转发过来就是「转发失败」"
      >
        <button className="btn" onClick={() => void q.reload()} disabled={q.loading}>
          {q.loading ? "正在读 ss@kaider.sg…" : "刷新"}
        </button>
      </PageHeading>
      {q.error && <div className="notice err">{q.error}</div>}
      <div className="card">
        <div className="list-bar">
          <span className="count">共 {rows.length} 位担保人 · 转发失败的排前面</span>
        </div>
        {q.loading && !q.data ? (
          <div className="empty">正在加载…</div>
        ) : (
          <DataTable columns={COLUMNS} rows={rows} rowKey={(s) => s.email} rowAttrs={() => ({ "data-testid": "sponsor-mail-row" })} empty="还没有任务填过担保人邮箱" />
        )}
      </div>
    </div>
  );
}
